import { defineStore } from "pinia";
import type { Talk } from "~/entities/Talk";

// トークルーム一時ビュー状態（メモリ保存）
export const useTalkRoomTmpViewStore = defineStore("TalkRoomTmpViewStore", () => {
  // トークルーム初回データクエリ → 表示 → スクロール完了判定
  const initRenderingFinished = ref(false);

  // 検索状態
  const canSearch = ref(false);
  const searchOpen = ref(false);
  const searchText = ref("");

  // スレッド表示状態
  const showThread = ref(false);
  const threadTalk = ref<Talk | undefined>();
  const threadTargetTalkId = ref<string | undefined>();

  const initPlan = () => {
    // 講座スコープの状態初期化
    canSearch.value = false;
    searchOpen.value = false;
    searchText.value = "";
  };

  const initTalkRoom = () => {
    // トークルームスコープの状態初期化
    initRenderingFinished.value = false;
    showThread.value = false;
    threadTalk.value = undefined;
    threadTargetTalkId.value = undefined;
  };

  return {
    initRenderingFinished,
    canSearch,
    searchOpen,
    searchText,

    showThread,
    threadTalk,
    threadTargetTalkId,
    initPlan,
    initTalkRoom,
  };
});
